import './style.css';

import createReactClass from 'create-react-class';
import Moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import PublishMixin from '../../../../mixins/publish-mixin';

export default createReactClass({
  displayName: 'calendar',
  mixins: [PublishMixin],

  getInitialState: function () {
    let val = this.get('value');

    return {
      date: new Moment(val || new Date()).startOf('day'),
      mode: this.props.displayMode || 'day',
      minYear: this.props.minYear + 10 || 1910,
      maxYear: this.props.maxYear - 10 || 9980
    };
  },

  getDefaultProps() {
    return {
      onChangeNoClose: () => {}
    };
  },

  UNSAFE_componentWillReceiveProps(n) {
    if (n.value && Moment(n.date).isValid()) {
      this.setState({ date: Moment(n.value) });
    }
  },

  mode: function (mode) {
    if (this.props.readOnly) return;
    this.setState({ mode: mode });
  },

  navigate: function (type, mode) {
    if (this.props.readOnly) return;
    if (mode == 'year') {
      if (this.state.date.year() < this.state.minYear && type == 'prev') return;
      if (this.state.date.year() > this.state.maxYear && type == 'next') return;
    }
    if (mode == 'month') {
      if (this.state.date.year() <= this.state.minYear - 10 && type == 'prev') return;
      if (this.state.date.year() >= this.state.maxYear + 10 && type == 'next') return;
    }
    let d = mode == 'day' ? 'month' : 'year';
    let i = mode == 'year' ? 10 : 1;

    let m = type == 'prev' ? this.state.date.subtract(i, d) : this.state.date.add(i, d);

    this.setState({ date: this.state.date });
  },

  select: function (mode, value) {
    if (this.props.readOnly) return;
    switch (mode) {
      case 'day':
        this.state.date.month(value);
        this.props.onChangeNoClose(this.state.date);
        break;
      case 'month':
        this.state.date.year(value);
        this.props.onChangeNoClose(this.state.date);
        break;
    }
    this.setState({
      date: this.state.date,
      mode: mode
    });
  },

  render: function () {
    let mode;
    switch (this.state.mode) {
      case 'day':
        mode = (
          <DayMode
            date={this.state.date}
            value={this.props.value}
            valueLink={this.props.valueLink}
            onChange={this.props.onChange}
            mode={this.mode}
            navigate={this.navigate}
            clearButton={this.props.clearButton}
          />
        );
        break;
      case 'month':
        mode = (
          <MonthMode
            date={this.state.date}
            select={this.select}
            mode={this.mode}
            navigate={this.navigate}
            minYear={this.state.minYear}
            maxYear={this.state.maxYear}
            clearButton={this.props.clearButton}
          />
        );
        break;
      case 'year':
        mode = (
          <YearMode
            date={this.state.date}
            select={this.select}
            mode={this.mode}
            navigate={this.navigate}
            minYear={this.state.minYear}
            maxYear={this.state.maxYear}
            clearButton={this.props.clearButton}
          />
        );
        break;
    }
    return <div style={this.props.style}>{mode}</div>;
  }
});

let DayMode = createReactClass({
  displayName: 'DayMode',
  mixins: [PublishMixin],

  propTypes: {
    navigate: PropTypes.func,
    select: PropTypes.func,
    mode: PropTypes.func,
    date: PropTypes.object,
    valueLink: PropTypes.object
  },

  getInitialState() {
    this.dateManuallySetToNull = false;
  },

  prev(e) {
    this.props.navigate('prev', 'day');
    e.preventDefault();
    e.stopPropagation();
  },

  next(e) {
    this.props.navigate('next', 'day');
    e.preventDefault();
    e.stopPropagation();
  },

  selectDate(e) {
    e.preventDefault();
    e.stopPropagation();
    const toSet = new Moment(e.target.dataset.date).toDate();
    this.publish(toSet);
  },

  levelUp(e) {
    this.props.mode('month');
    e.preventDefault();
    e.stopPropagation();
  },

  render() {
    let start = new Moment(this.props.date).startOf('month');
    let finish = new Moment(this.props.date).endOf('month');
    const val = (this.props.valueLink || this.props).value;
    const today = new Moment().startOf('day').toDate().valueOf();

    start = start.subtract(start.day(), 'day');
    finish = finish.add(6 - finish.day(), 'day');

    const date = new Moment(start.toDate());
    const rows = [];

    while (date.toDate() < finish.toDate()) {
      const cells = [];
      for (let d = 0; d < 7; d++) {
        const ds = date.format('YYYY-MM-DD');
        let className = 'day ';
        className += !date.isSame(this.props.date, 'Month') ? 'disabled ' : '';
        className += date.startOf('day').toDate().valueOf() === today ? 'today ' : '';
        if (!!val) {
          className += date.startOf('day').toDate().valueOf() === val.valueOf() ? 'selected ' : '';
        }
        cells.push(
          <td
            key={d}
            className={className}
            onClick={this.selectDate}
            data-date={ds}
            data-test-id={`calendar-day-${ds}`}
          >
            {date.date()}
          </td>
        );
        date.add(1, 'day');
      }
      rows.push(<tr>{React.Children.toArray(cells)}</tr>);
    }

    return (
      <div className="bz-calendar">
        <table>
          <thead>
            <tr>
              <td className="navigation" onClick={this.prev} data-test-id="calendar-nav-prev">
                <a>&#9668;</a>
              </td>
              <td
                className="description"
                colSpan="5"
                onClick={this.levelUp}
                data-test-id="calendar-month-year-header"
              >
                {this.props.date.format('MMMM YYYY')}
              </td>
              <td className="navigation" onClick={this.next} data-test-id="calendar-nav-next">
                <a>&#9658;</a>
              </td>
            </tr>
            <tr>
              <td className="week-day">Sun</td>
              <td className="week-day">Mon</td>
              <td className="week-day">Tue</td>
              <td className="week-day">Wed</td>
              <td className="week-day">Thu</td>
              <td className="week-day">Fri</td>
              <td className="week-day">Sat</td>
            </tr>
          </thead>
          <tbody>{React.Children.toArray(rows)}</tbody>
        </table>
        {this.props.clearButton}
      </div>
    );
  }
});

class MonthMode extends React.Component {
  static propTypes = {
    navigate: PropTypes.func,
    select: PropTypes.func,
    mode: PropTypes.func,
    date: PropTypes.object
  };

  prev = (e) => {
    this.props.navigate('prev', 'month');
    e.preventDefault();
    e.stopPropagation();
  };

  next = (e) => {
    this.props.navigate('next', 'month');
    e.preventDefault();
    e.stopPropagation();
  };

  levelUp = (e) => {
    this.props.mode('year');
    e.preventDefault();
    e.stopPropagation();
  };

  select = (e) => {
    this.props.select('day', parseInt(e.target.dataset.month, 10));
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    let prevBtn;
    let nextBtn;
    let yearRange = this.props.date._d.getFullYear();
    prevBtn = yearRange > this.props.minYear - 10 ? <a>&#9668;</a> : '';
    nextBtn = yearRange < this.props.maxYear + 10 ? <a>&#9658;</a> : '';

    return (
      <div className="bz-calendar">
        <table>
          <thead>
            <tr>
              <td className="navigation" onClick={this.prev} data-test-id="calendar-nav-prev-year">
                {prevBtn}
              </td>
              <td
                className="description"
                onClick={this.levelUp}
                data-test-id="calendar-year-header"
              >
                {this.props.date.format('YYYY')}
              </td>
              <td className="navigation" onClick={this.next} data-test-id="calendar-nav-next-year">
                {nextBtn}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                className="month"
                onClick={this.select}
                data-month="0"
                data-test-id="calendar-month-0"
              >
                Jan
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="1"
                data-test-id="calendar-month-1"
              >
                Feb
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="2"
                data-test-id="calendar-month-2"
              >
                Mar
              </td>
            </tr>
            <tr>
              <td
                className="month"
                onClick={this.select}
                data-month="3"
                data-test-id="calendar-month-3"
              >
                Apr
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="4"
                data-test-id="calendar-month-4"
              >
                May
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="5"
                data-test-id="calendar-month-5"
              >
                Jun
              </td>
            </tr>
            <tr>
              <td
                className="month"
                onClick={this.select}
                data-month="6"
                data-test-id="calendar-month-6"
              >
                Jul
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="7"
                data-test-id="calendar-month-7"
              >
                Aug
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="8"
                data-test-id="calendar-month-8"
              >
                Sept
              </td>
            </tr>
            <tr>
              <td
                className="month"
                onClick={this.select}
                data-month="9"
                data-test-id="calendar-month-9"
              >
                Oct
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="10"
                data-test-id="calendar-month-10"
              >
                Nov
              </td>
              <td
                className="month"
                onClick={this.select}
                data-month="11"
                data-test-id="calendar-month-11"
              >
                Dec
              </td>
            </tr>
          </tbody>
        </table>
        {this.props.clearButton}
      </div>
    );
  }
}

class YearMode extends React.Component {
  static propTypes = {
    navigate: PropTypes.func,
    select: PropTypes.func,
    date: PropTypes.object,
    minDate: PropTypes.object,
    maxDate: PropTypes.object
  };

  prev = (e) => {
    this.props.navigate('prev', 'year');
    e.preventDefault();
    e.stopPropagation();
  };

  next = (e) => {
    this.props.navigate('next', 'year');
    e.preventDefault();
    e.stopPropagation();
  };

  select = (e) => {
    this.props.select('month', parseInt(e.target.dataset.year, 10));
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const root = Math.floor(this.props.date.year() / 10) * 10 - 1;
    const rows = [];
    for (let r = 0; r < 4; r++) {
      const cells = [];
      for (let c = 0; c < 3; c++) {
        const i = r * 3 + c;
        const className = 'month ' + (i === 0 || i === 11 ? 'disabled' : '');
        cells.push(
          <td
            key={r + '-' + c}
            className={className}
            onClick={this.select}
            data-year={root + i}
            data-test-id={`calendar-year-${root + i}`}
          >
            {root + i}
          </td>
        );
      }
      rows.push(<tr>{React.Children.toArray(cells)}</tr>);
    }

    let prevBtn;
    let nextBtn;
    let yearRange = this.props.date._d.getFullYear();
    prevBtn = yearRange >= this.props.minYear ? <a>&#9668;</a> : '';
    nextBtn = yearRange <= this.props.maxYear ? <a>&#9658;</a> : '';

    return (
      <div className="bz-calendar">
        <table>
          <thead>
            <tr>
              <td
                className="navigation"
                onClick={this.prev}
                data-test-id="calendar-nav-prev-decade"
              >
                {prevBtn}
              </td>
              <td className="description decade" data-test-id="calendar-decade-header">
                {root + 1}
                &nbsp;-&nbsp;
                {root + 10}
              </td>
              <td
                className="navigation"
                onClick={this.next}
                data-test-id="calendar-nav-next-decade"
              >
                {nextBtn}
              </td>
            </tr>
          </thead>
          <tbody>{React.Children.toArray(rows)}</tbody>
        </table>
        {this.props.clearButton}
      </div>
    );
  }
}
